import { CartDeliveryAddress } from '../../components/customer/cart/addresses/cart-delivery-address.component.tsx';
import { CartStack } from '../../components/customer/cart/cart-stack.component';

export function ExternalCartAddressesPage() {
  return (
    <CartStack>
      <CartDeliveryAddress />
    </CartStack>
  );
}
